import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import MarketingLayout from "../marketing/components/MarketingLayout";

const ARTICLES = [
  {
    to: "/resource/logiciel-ATS-optimisation-CV",
    badge: "ATS",
    title: "Optimiser son CV pour un logiciel ATS",
    preview: "Découvrez les stratégies essentielles pour adapter votre CV aux systèmes de recrutement automatisés. Apprenez à structurer vos informations, utiliser les bons mots-clés et maximiser vos chances de passer les filtres ATS pour décrocher plus d'entretiens.",
  },
  {
    to: "/ressources/logiciel-ATS-astuces",
    badge: "10×",
    title: "10 astuces pour passer les filtres ATS",
    preview: "Maîtrisez les techniques avancées pour optimiser votre CV et contourner les systèmes de tri automatique. Ces conseils pratiques vous aideront à améliorer significativement votre taux de réponse aux offres d'emploi.",
  },
  {
    to: "/ressources/template-cv",
    badge: "TPL",
    title: "Template CV efficace 2024",
    preview: "Téléchargez notre modèle de CV moderne et professionnel, spécialement conçu pour 2024. Ce template optimisé ATS vous donne tous les outils pour créer un CV qui se démarque et attire l'attention des recruteurs.",
  },
  {
    to: "/ressources/erreurs-cv",
    badge: "ERR",
    title: "Les 5 erreurs à éviter sur son CV",
    preview: "Identifiez et corrigez les erreurs les plus courantes qui peuvent faire échouer votre candidature. Apprenez à éviter ces pièges pour maximiser vos chances de succès dans votre recherche d'emploi.",
  },
  {
    to: "/ressources/modele-lettre-motivation",
    badge: "LM",
    title: "Modèle de lettre de motivation moderne",
    preview: "Rédigez des lettres de motivation percutantes avec notre modèle moderne et nos conseils d'experts. Apprenez à personnaliser votre approche et à vous démarquer auprès des employeurs potentiels.",
  },
  {
    to: "/ressources/competences-cv",
    badge: "SK",
    title: "Compétences clés à valoriser sur un CV",
    preview: "Découvrez comment identifier, structurer et mettre en valeur vos compétences pour créer un CV impactant. Nos conseils vous aideront à présenter votre profil de manière attractive et professionnelle.",
  },
  {
    to: "/ressources/linkedin-optimisation",
    badge: "IN",
    title: "Optimiser son profil LinkedIn",
    preview: "Transformez votre profil LinkedIn en un outil de networking puissant. Apprenez les techniques pour attirer les recruteurs, développer votre réseau professionnel et maximiser votre visibilité sur la plateforme.",
  },
];

const Articles = () => (
  <MarketingLayout>
    <Helmet>
      <title>Articles & Ressources - ASAP Hub</title>
      <meta name="description" content="Découvrez nos articles et ressources pour optimiser votre recrutement, vos CV et votre sourcing avec ASAP Hub." />
      <link rel="canonical" href="https://www.asap-hub.ai/articles" />
    </Helmet>

    <header className="mk-legal-hero">
      <div className="mk-wrap">
        <span className="mk-eyebrow">
          <span className="mk-pulse" aria-hidden="true" />
          Ressources ASAP Hub
        </span>
        <h1>Articles &amp; guides</h1>
        <p className="mk-lead">
          Conseils d'experts, bonnes pratiques et guides pour optimiser votre recrutement et booster la performance de votre ESN.
        </p>
      </div>
    </header>

    <section className="mk-section soft">
      <div className="mk-wrap">
        <div className="mk-articles-grid">
          {ARTICLES.map((a) => (
            <Link key={a.to} to={a.to} className="mk-article-card mk-reveal" data-testid="article-card">
              <div className="mk-article-thumb">
                <span className="mk-article-badge" aria-hidden="true">{a.badge}</span>
              </div>
              <div className="mk-article-body">
                <h3>{a.title}</h3>
                <p>{a.preview}</p>
                <span className="mk-article-cta">Lire le guide →</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  </MarketingLayout>
);

export default Articles;
